/* eslint-disable */
import {
  Checkbox,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import * as React from 'react';

export function CheckFilter({
  items,
  name,
  selectedItems = [],
  setSelectedItems,
  open = false,
}) {
  const [openMenu, setOpenMenu] = React.useState(open);
  const toggleItem = ({ currentTarget: input }) => {
    if (input.checked) {
      setSelectedItems([...selectedItems, input.value]);
    } else {
      const idx = selectedItems.indexOf(input.value);
      if (idx === -1) {
        return;
      }
      const newItems = [
        ...selectedItems.slice(0, idx),
        ...selectedItems.slice(idx + 1),
      ];

      setSelectedItems(newItems);
    }
  };

  const clearItems = () => {
    setSelectedItems([]);
  };
  const translateName = (name) => {
    switch (name) {
      case 'Type':
        return 'Tipo';
      case 'Brands':
        return 'Marcas';
      case 'Tags':
        return 'Etiquetas';
      default:
        return 'Varios';
    }
  };

  const handleToggleMenu = () => setOpenMenu(!openMenu);

  if (name) {
    return (
      <>
        <ListItem button onClick={handleToggleMenu}>
          <ListItemText primary={translateName(name)} />
          {openMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding dense>
            {items.map((item) => (
              <ListItem
                button
                key={JSON.stringify(item)}
                selected={selectedItems.includes(item)}
              >
                <ListItemText primary={item} />
                <ListItemIcon>
                  <Checkbox
                    color="primary"
                    value={item}
                    onChange={toggleItem}
                    edge="end"
                    checked={selectedItems.includes(item)}
                  />
                </ListItemIcon>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return null;
}
